//=====================================================
//　メッセージ定義ファイル
//=====================================================
//-----------------------------------------------------
//　メッセージ定義
//-----------------------------------------------------
export enum ConstMsg {
    EG0020001 = "治療メニューを選択してから次へ進んでください。",
    EG0020002 = "サーバーに接続できませんでした。再度実行してください。",
    EG0030001 = "サーバーに接続できませんでした。再度実行してください。",
    EG0040001 = "「{1}」を入力してください。",
    EG0040002 = "「{1}」は、ひらがなで入力してください。",
    EG0040003 = "「{1}」は、{2}文字以内で入力してください。",
    EG0040004 = "正しい「生年月日」を選択してください。",
    EG0040005 = "今日より未来の日が選択されています。正しい「生年月日」を選択してください。",
    EG0040006 = "「{1}」は、半角数字/ハイフンで入力してください。",
    EG0040007 = "「固定電話番号」は、市外局番から入力してください。",
    EG0040008 = "「メールアドレス」の形式に誤りがあります。正しい「メールアドレス」を入力してください。",
    EG0040009 = "利用規約をご確認の上、チェックしてください。",
    EG0040010 = "入力された患者情報は既に登録されています。",
    EG0040011 = "携帯電話番号・固定電話番号のどちらかを入力してください。",
    EG0040012 = "「携帯電話番号」は、「090」「080」「070」「060」で始まる11桁の電話番号を入力してください。",
    EG0040013 = "「固定電話番号」は、10桁の番号または「050」で始まる11桁の電話番号を入力してください。",
    EG0040014 = "「携帯電話番号」は11桁の正しい形式で入力してください。",
    EG0050001 = "「{1}」は、{2}文字以内で入力してください。",
    EG0210001 = "「パスワード」と「パスワード再入力」は同じ値を入力してください。",
    IG0210001 = "通知するにチェックをした場合、来院時に、そのことをご指定の宛先に通知します。\nご家族の来院状況を確認する際にご利用ください。",
    IG0210002 = "通知するにチェックをした場合、治療終了時に、そのことをご指定の宛先に通知します。\nご家族の退院状況を確認する際にご利用ください。",
    EG0080001 = "「{1}」を入力してください。",
    EG0080002 = "「{1}」は、半角英数字で入力してください。",
    EG0080003 = "「{1}」の形式が正しくありません。",
    EG0080004 = "「{1}」は、{2}文字以内で入力してください。",
    EG0110001 = "使用できない文字「\\\"<>;'`」が含まれています。",

    EG9010001 = "治療種別が正しく指定されていません。",
    EG9990001 = "サーバーに接続できませんでした。再度実行してください。",
    EG9990002 = "ページが見つかりません。"
}

//-----------------------------------------------------
//　メッセージ取得関数
//-----------------------------------------------------
export function getMsg(msg:string, param:string[]){

    let retMsg = msg;

    //置換文字検索
    const pattern = /(\{\d+\})/g;
    const replaceChr = msg.match(pattern);
    let idx = 0;
    if (replaceChr){
        replaceChr.forEach(function(val){
            if (param[idx]){
                retMsg = retMsg.replace(val, param[idx]);
            }
            idx++;
        });
    }

    return retMsg;

}